import React from 'react';
import {observer} from "mobx-react-lite";
import {useServices} from "../../../hooks/use-services.hook";
import {InputContainerComponent} from "../../forms/input-container/input-container.component";
import styled from "styled-components";
import {SearchMaskPsoMarketUserOptionsComponent} from "./search-mask-pso-market-user-options.component";


const OptionsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${props => props.theme.spacing.flexGap8};
`


export const SearchMaskPsoMarketUserOptionsInputSmallScreenComponent: React.FC = observer(() => {
    const services = useServices();
    const searchController = services.flightSearch.searchController;

    if(!searchController.psoMarket) {
        return null;
    }


    const renderInput = () => {
        return (
            <OptionsContainerBox>
                <SearchMaskPsoMarketUserOptionsComponent searchController={searchController} mode={"inline"}/>
            </OptionsContainerBox>
        )
    }

    const errorMessage = searchController.fields.psoUserOption.error;

    return (
        <InputContainerComponent renderInput={renderInput} errorMessage={errorMessage}/>
    );
})
